module.exports = __webpack_public_path__ + "img/windows.954b99fd.png";